import Box, { BoxProps } from "@mui/material/Box";

interface FontIconProps {
    sx?: BoxProps['sx'];
    children: string;
}

export function FontIcon({ children, sx }: FontIconProps) {
    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                fontSize: 14,
                fontWeight: 'bold',
                fontFamily: 'Roboto, Arial, sans-serif',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                ...sx
            }}
        >
            {children}
        </Box>
    );
}

export default FontIcon;